// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face {\r\n    font-family: 'Open Sans Regular';\r\n    src: url(\"https://www.rai.it/dl/components/fonts/OpenSans-Regular.woff2\") format(\"woff2\");\r\n    font-style: normal;\r\n}", ""]);
// Exports
module.exports = exports;
